import gql from "graphql-tag";

export const ADD_DEAL = gql`
  mutation insert_deals_one(
    $name: String!
    $type: deal_type_enum!
    $condition: String!
    $description: String
    $expire_date_time: timestamp
    $image_path: String
    $image_url: String
    $business_profile_id: uuid
    $club_profile_id: uuid
  ) {
    insert_deals_one(
      object: {
        name: $name
        type: $type
        condition: $condition
        description: $description
        expire_date_time: $expire_date_time
        image_path: $image_path
        image_url: $image_url
        business_profile_id: $business_profile_id
        club_profile_id: $club_profile_id
      }
    ) {
      id
    }
  }
`;
